import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Form, FormInput } from 'shared/components'
import * as styles from './styles'

import { LinkedSelect } from './components/linkedSelect'

const EventsFiltersComponent = ({ form, loadSportTypes, loadTournaments }) => (
  <Form form={form}>
    <Grid>
      <Row css={styles.row}>
        <Col xs={12} sm={8} md={6}>
          <FormInput
            fluid
            type="custom"
            name="linkedSportTournament"
            loadSportTypes={loadSportTypes}
            loadTournaments={loadTournaments}
            renderComponent={LinkedSelect}
            oldInput
            iconOptioned
            size="medium"
          />
        </Col>
        <Col xs={12} sm={4} md={6}>
          <FormInput
            inlineIcon="Search"
            fluid
            name="search"
            icon="search"
            placeholder="Search"
            grayBg
            size="medium"
          />
        </Col>
      </Row>
    </Grid>
  </Form>
)

EventsFiltersComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  loadSportTypes: PropTypes.func.isRequired,
  loadTournaments: PropTypes.func.isRequired,
}

export default EventsFiltersComponent
